module.exports = "https://la-static.vkplay.ru/promo/newstart/img/feature-peaceful.2be07014.jpg";